import { render, staticRenderFns } from "./ThePersonalLinkCard.vue?vue&type=template&id=7b9c79b0&"
import script from "./ThePersonalLinkCard.vue?vue&type=script&lang=js&"
export * from "./ThePersonalLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalLinkCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports